import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import axios from 'axios'
import moment from 'moment'

import { Button, Row, Col } from 'reactstrap'

import InputGroup from '../../../common/InputGroup'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import CustomDataPicker from '../../../common/ReactDatePicker/ReactDatePicker'

import { getUsersForCustomSelectByDivision } from '../../Users/redux/userActions'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import { clearAllErrors } from '../../../actions/errorsActions'
import { editReferralData, saveReferral, cleanUpReferralData } from './redux/ReferralActions'
import isEmpty from '../../../utils/isEmpty'

const Referral = ({
  isModal,
  errors,
  getUsersForCustomSelectByDivision,
  usersForCustomSelect,
  editReferralData,
  data,
  saveReferral,
  referralData,
  cleanUpReferralData,
  clearAllErrors,
  closeModal,
  isReferred,
}) => {
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState({
    EffortLevel: [],
    ProspectGrade: [],
  })
  const [systemSettings, setSystemSettings] = useState({
    hot: 0,
    cold: 0,
    warm: 0,
  })

  useEffect(() => {
    if (referralData?.effortLevel) {
      if (referralData.effortLevel === 'A') {
        editReferralData('effort_level', 122)
      } else if (referralData.effortLevel === 'B') {
        editReferralData('effort_level', 123)
      } else if (referralData.effortLevel === 'C') {
        editReferralData('effort_level', 124)
      }
    }
  }, [])

  const PROSPECT_GRADE = 10
  const EFFORT_LEVEL = 13
  useEffect(() => {
    const loadData = async () => {
      const response = await axios.get(
        `/support-types/supportTypesForSelects/?types=${PROSPECT_GRADE}&types=${EFFORT_LEVEL}`
      )
      let options = {}
      response.data.map((i) => {
        return (options[i.name.replace(/\s/g, '')] = i.data)
      })
      let ProspectGrade = []
      options.ProspectGrade.forEach((item) => {
        if (item.name === 'Cold') {
          ProspectGrade[0] = item
        } else if (item.name === 'Hot') {
          ProspectGrade[2] = item
        } else {
          ProspectGrade[1] = item
        }
      })
      options.ProspectGrade = ProspectGrade
      setOptions(options)
    }

    const loadSystemSettings = async () => {
      const response = await axios.get(`/system-config/all-divisions`)
      setSystemSettings(response.data)
    }
    editReferralData('divisionId', referralData.id)
    editReferralData('contactId', referralData.contactId)
    editReferralData('subject', `Contact Referral to ${referralData.divisionName}`)

    getUsersForCustomSelectByDivision(referralData.id)
    loadData()
    loadSystemSettings()
    return function cleanup() {
      cleanUpReferralData()
      clearAllErrors()
    }
  }, [])

  const handleGradeChange = (e) => {
    editReferralData('grade', e.id)
    // if (e.id === WARM) {
    //   editReferralData('dueDate', moment().utc(false))
    // } else if (e.id === HOT) {
    //   editReferralData('dueDate', moment().utc(false).add(1, 'days'))
    // } else if (e.id === COLD) {
    //   editReferralData('dueDate', moment().utc(false).add(2, 'days'))
    // }
    if (e.id) {
      const name = options.ProspectGrade.find((i) => i.id === e.id).name
      const days = systemSettings[name.toLowerCase()]
      editReferralData(
        'dueDate',
        moment()
          // .utc(false)
          .hours(17)
          .minutes(0)
          .add(days > 0 ? days - 1 : days, 'days')
      )
    }
  }

  const createReferral = async () => {
    setLoading(true)
    await saveReferral()
    setLoading(false)
  }

  const getBody = () => {
    return (
      <>
        {!isEmpty(isReferred) && (
          <Row>
            <h3 style={{ color: 'red' }}>Contact is already referred to {isReferred.userData.name}</h3>
          </Row>
        )}
        <Row>
          <Col xs={12} md={12} lg={6}>
            <InputGroup
              label='Subject'
              name='subject'
              value={data.subject}
              onChange={(e) => editReferralData(e.target.name, e.target.value)}
              disabled={!isEmpty(isReferred)}
            />
          </Col>
          <Col xs={12} md={12} lg={3}>
            <CustomSelect
              label='Effort Level'
              onChange={(e) => editReferralData('effort_level', e.id)}
              options={[{ name: 'Not Rated', id: null }, ...options.EffortLevel]}
              defaultValue={data.effort_level}
              invalid={!!errors.effort_level}
              errorMess={errors.effort_level}
              disabled={!isEmpty(isReferred) || !!referralData?.effortLevel}
            />
          </Col>
          <Col xs={12} md={12} lg={3}>
            <CustomSelect
              label='Grade'
              onChange={(e) => handleGradeChange(e)}
              options={[{ name: '-- Select --', id: null }, ...options.ProspectGrade]}
              defaultValue={data.grade}
              invalid={!!errors.grade}
              errorMess={errors.grade}
              disabled={!isEmpty(isReferred)}
            />
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col xs={12} md={12} lg={6}>
            <CustomSelect
              label='Attention To'
              onChange={(e) => editReferralData('attention_to', e.id)}
              options={[{ name: 'Please Select', id: null }, ...usersForCustomSelect]}
              defaultValue={data.attention_to}
              invalid={!!errors.attention_to}
              errorMess={errors.attention_to}
              disabled={!isEmpty(isReferred)}
            />
          </Col>
          <Col xs={12} md={12} lg={6}>
            <CustomDataPicker
              selected={data.dueDate ? new Date(data.dueDate) : ''}
              onChange={(date) => editReferralData('dueDate', date)}
              label='Due Date/Time'
              showTimeSelect
              showTimeInput
              isClearable
              placeholder='mm/dd/yyyy'
              disabled={!isEmpty(isReferred)}
            />
          </Col>
        </Row>
        <div className='mt-5'>
          <InputGroup
            style={{ height: '100px' }}
            label='Notes'
            name='note'
            type='textarea'
            onChange={(e) => editReferralData(e.target.name, e.target.value)}
            value={data.note}
            disabled={!isEmpty(isReferred)}
          />
        </div>
        <Row className='mt-3'>
          <Col className='text-left'>
            <Button className={'btn btn-gold'} onClick={() => closeModal('referral')}>
              Cancel
            </Button>
          </Col>

          <Col className='text-right'>
            <Button className={'btn btn-gold'} onClick={createReferral} disabled={!isEmpty(isReferred) || loading}>
              Ok
            </Button>
          </Col>
        </Row>
      </>
    )
  }
  if (!isModal) {
    return getBody()
  }
  return <>{getBody()}</>
}

Referral.propTypes = {
  isModal: PropTypes.bool,
  isModalToggle: PropTypes.bool,
  contactName: PropTypes.string,
  usersForCustomSelect: PropTypes.array,
  getUsersForCustomSelectByDivision: PropTypes.func.isRequired,
  editReferralData: PropTypes.func.isRequired,
  data: PropTypes.object,
  referralData: PropTypes.object.isRequired,
  saveReferral: PropTypes.func.isRequired,
  cleanUpReferralData: PropTypes.func.isRequired,
  clearAllErrors: PropTypes.func.isRequired,
  errors: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
}

Referral.defaultProps = {
  isModal: true,
  isModalToggle: false,
  usersForCustomSelect: [],
  contactName: '',
  data: {},
  errors: {},
}

const mapStateToProps = (state) => {
  return {
    contactName: state.Task.contactName,
    usersForCustomSelect: state.users.usersForCustomSelect,
    data: state.Referral.data,
    isReferred: state.Referral.isReferred,
    errors: state.errors.error,
  }
}

export default connect(mapStateToProps, {
  getUsersForCustomSelectByDivision,
  editReferralData,
  saveReferral,
  cleanUpReferralData,
  clearAllErrors,
  closeModal,
})(Referral)
